/**
 * Centralizes Browser API-subscription cleanup shared by manual and automatic logout paths.
 */
import {getQepSystem} from '@qep/shared/src';

/** Attempts synchronous subscription cleanup and logs failures so authentication logout can continue. */
export function cleanupSubscriptionsBeforeLogout(): void {
  try {
    getQepSystem().apiServices?.unsubscribeAndCleanup?.();
  } catch (error) {
    console.error('Failed to clean up subscriptions before logout', error);
  }
}
